// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"379e7516","453":"1676e0b5","627":"32af5023","905":"6b5d44de","923":"2fbe80f7"}[chunkId] + ".chunk.js";
};